---
nb:
  budget_import:
    dialog_title: Importer budsjettdata
    file_too_large: Filen er for stor
    import_button: Importer budsjettdata
    invalid_file: Filen kunne ikke leses. Den kan være skadet eller i feil format.
    no_file_selected: Vennligst velg en fil å laste opp
    select_file: Velg XLSX eller CSV fil
    upload: Last opp
    upload_failed: Kunne ikke laste opp fil
  budget_tabs:
    charts: Grafer
    tables: Tabeller
  budgets:
    edit_title: Budsjett for
